import { initializeApp, getApps, getApp } from "firebase/app"

import {
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth"

import {
  getFirestore,
} from "firebase/firestore"

import {
  getStorage,
} from "firebase/storage"

/* =========================
   FIREBASE CONFIG
========================= */

const firebaseConfig = {
  apiKey: "AIzaSyAvFS8Ub2XZz-kpVawQuDgKI1YUU8VJdPo",
  authDomain: "area-4b.firebaseapp.com",
  databaseURL: "https://area-4b-default-rtdb.firebaseio.com",
  projectId: "area-4b",
  storageBucket: "area-4b.appspot.com",
  messagingSenderId: "1064234590151",
  appId: "1:1064234590151:web:f61cddcd37a69740a683e2",
  measurementId: "G-LG86204Q49"
};

/* =========================
   APP
========================= */

export const firebaseApp =
  getApps().length > 0
    ? getApp()
    : initializeApp(firebaseConfig)

/* =========================
   SERVICES
========================= */

export const db = getFirestore(firebaseApp)

export const auth = getAuth(firebaseApp)

export const storage = getStorage(firebaseApp)

/* =========================
   PROVIDERS
========================= */

export const googleProvider =
  new GoogleAuthProvider()